'use strict';

module.exports = Object.getOwnPropertyNames;